import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../UI/Icon';
import sprechheldenHeld from '../../assets/sprechheldenHeld.png';

function TopNavigation({ activeGame }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isDashboard = location.pathname === '/dashboard';

  return (
    <Navbar
      className="top-navigation"
    >
      <Container fluid>
        <Navbar.Brand
          className="brand-logo"
          onClick={() => navigate('/menu')}
          style={{ cursor: 'pointer' }}
        >
          <img
            src={sprechheldenHeld}
            alt="Sprechhelden Hero"
            className="brand-icon me-2"
          />
          <span className="brand-text-black">Sprechhelden</span>
        </Navbar.Brand>

        {isDashboard && (
          <Nav className="ms-auto">
            <Nav.Link
              onClick={() => navigate('/menu')}
              className="d-flex align-items-center btn btn-primary"
              style={{
                cursor: 'pointer',
                backgroundColor: '#88D8B0',
                color: '#4A4A4A',
                border: 'none',
                borderRadius: '20px',
                padding: '8px 35px',
                fontWeight: 'bold',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#5BB884'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#88D8B0'}
            >
              Menü
            </Nav.Link>
          </Nav>
        )}

      </Container>
    </Navbar>
  );
}

export default TopNavigation;